import React from "react";

export const HabitIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none">
      <path
        d="M23.4094 20.1543H17.9023L16.5742 21.4824H23.4094V20.1543Z"
        fill="#2481A6"
      />
      <path
        d="M18.5664 19.4892H22.2533C22.0368 18.5877 21.6048 17.762 20.9873 17.0684L18.5664 19.4892Z"
        fill="#2481A6"
      />
      <path
        d="M12.5503 24.5674L14.9712 22.1465H11.2842C11.5008 23.048 11.9327 23.8737 12.5503 24.5674Z"
        fill="#2481A6"
      />
      <path
        d="M10.1289 20.1543V21.4824H12.7852V20.1543C12.1548 20.1543 10.7869 20.1543 10.1289 20.1543Z"
        fill="#2481A6"
      />
      <path
        d="M22.2532 22.1465H15.91L13.0195 25.0369C14.0537 25.9583 15.3722 26.4629 16.7686 26.4629C19.4255 26.4629 21.6562 24.6321 22.2532 22.1465Z"
        fill="#2481A6"
      />
      <path
        d="M16.964 20.1543H13.4492V21.4824H15.6359L16.964 20.1543Z"
        fill="#2481A6"
      />
      <path
        d="M12.7775 16.828C12.0376 17.5679 11.5265 18.4823 11.2842 19.4911H17.6274L20.5178 16.6007C18.3039 14.6307 14.8995 14.706 12.7775 16.828Z"
        fill="#2481A6"
      />
      <path
        d="M30.3828 4.88086C30.9321 4.88086 31.3789 4.43401 31.3789 3.88477C31.3789 3.33552 30.9321 2.88867 30.3828 2.88867C29.8336 2.88867 29.3867 3.33552 29.3867 3.88477C29.3867 4.43408 29.8335 4.88086 30.3828 4.88086Z"
        fill="#2481A6"
      />
      <path
        d="M4.81641 27.127C3.71791 27.127 2.82422 28.0206 2.82422 29.1191C2.82422 30.2176 3.71791 31.1113 4.81641 31.1113C5.9149 31.1113 6.80859 30.2176 6.80859 29.1191C6.80859 28.0206 5.9149 27.127 4.81641 27.127Z"
        fill="#2481A6"
      />
      <path
        d="M30.6789 14.2413L28.7222 12.7599V8.05168C28.7222 6.93254 27.8279 6.02211 26.7287 6.02211C26.7162 6.02211 26.704 6.02224 26.6915 6.02251C25.6142 6.04296 24.7377 6.93646 24.7377 8.0143V9.74352L17.1836 4.02435C17.0659 3.93523 16.9035 3.9345 16.785 4.02275L3.33426 14.0312C2.91192 14.3453 2.64769 14.8267 2.60937 15.3518C2.53321 16.3955 3.35791 17.2939 4.41536 17.2939C4.80735 17.2939 5.18089 17.1701 5.49559 16.9359L16.9632 8.40317L28.4911 17.1305C29.2051 17.671 30.2166 17.6145 30.8664 16.9647C31.6429 16.1882 31.5539 14.9036 30.6789 14.2413Z"
        fill="#2481A6"
      />
      <path
        d="M26.2707 20.5879C26.0873 20.5879 25.9387 20.7365 25.9387 20.9199C25.9387 25.9195 21.8713 29.987 16.8717 29.987C11.8721 29.987 7.80469 25.9195 7.80469 20.9199C7.80469 20.7365 7.65607 20.5879 7.47266 20.5879C7.28924 20.5879 7.14062 20.7365 7.14062 20.9199C7.14062 26.2857 11.506 30.651 16.8717 30.651C22.2375 30.651 26.6028 26.2857 26.6028 20.9199C26.6028 20.7365 26.4541 20.5879 26.2707 20.5879Z"
        fill="#2481A6"
      />
      <path
        d="M23.8818 5.25195C24.1569 5.25195 24.3799 5.02897 24.3799 4.75391C24.3799 4.47884 24.1569 4.25586 23.8818 4.25586C23.6068 4.25586 23.3838 4.47884 23.3838 4.75391C23.3838 5.02897 23.6068 5.25195 23.8818 5.25195Z"
        fill="#2481A6"
      />
      <path
        d="M30.5488 21.1504C30.8239 21.1504 31.0469 20.9274 31.0469 20.6523C31.0469 20.3773 30.8239 20.1543 30.5488 20.1543C30.2738 20.1543 30.0508 20.3773 30.0508 20.6523C30.0508 20.9274 30.2738 21.1504 30.5488 21.1504Z"
        fill="#2481A6"
      />
      <path
        d="M11.291 3.55273C11.5661 3.55273 11.7891 3.32975 11.7891 3.05469C11.7891 2.77962 11.5661 2.55664 11.291 2.55664C11.016 2.55664 10.793 2.77962 10.793 3.05469C10.793 3.32975 11.016 3.55273 11.291 3.55273Z"
        fill="#2481A6"
      />
      <path
        d="M4.65039 8.20117C4.92545 8.20117 5.14844 7.97819 5.14844 7.70312C5.14844 7.42806 4.92545 7.20508 4.65039 7.20508C4.37533 7.20508 4.15234 7.42806 4.15234 7.70312C4.15234 7.97819 4.37533 8.20117 4.65039 8.20117Z"
        fill="#2481A6"
      />
      <path
        d="M4.98236 21.8143C5.25738 21.8143 5.48034 21.5914 5.48034 21.3163C5.48034 21.0413 5.25738 20.8184 4.98236 20.8184C4.70733 20.8184 4.48438 21.0413 4.48438 21.3163C4.48438 21.5914 4.70733 21.8143 4.98236 21.8143Z"
        fill="#2481A6"
      />
      <path
        d="M10.9589 31.4432C11.2339 31.4432 11.4569 31.2203 11.4569 30.9452C11.4569 30.6702 11.2339 30.4473 10.9589 30.4473C10.6839 30.4473 10.4609 30.6702 10.4609 30.9452C10.4609 31.2203 10.6839 31.4432 10.9589 31.4432Z"
        fill="#2481A6"
      />
      <path
        d="M27.2285 30.4473C27.5036 30.4473 27.7266 30.2243 27.7266 29.9492C27.7266 29.6742 27.5036 29.4512 27.2285 29.4512C26.9535 29.4512 26.7305 29.6742 26.7305 29.9492C26.7305 30.2243 26.9535 30.4473 27.2285 30.4473Z"
        fill="#2481A6"
      />
    </svg>
  );
};
